import { makeFilterFunction, optionOperation } from './utility.js'
export function textmatch(a, q) {
  let text = a.text;
  if (text?.constructor.name === "Object") text = text.text
  else if (text?.constructor.name === "Array") text = text.map(d => d.text).join(" ");

  if (!text && q) return true;
  else if (!text) return false;
  else if (!q) return false;

  if (q.constructor.name === "String") {
    if (text !== q) return false;
    else return true;
  } else if (q.constructor.name === "Array" && q.every(d => d.constructor.name === "String")) {
    if (text !== q.join(" ")) return false;
    else return true;
  } else if (q.constructor.name === "Object") {
    if (q.startsWith && !text.startsWith(q.startsWith)) return false;
    if (q.endsWith && !text.endsWith(q.endsWith)) return false;
    if (q.includes && !text.includes(q.includes)) return false;
    if (q.eq && !text !== q.eq) return false;
    if (q.neq && !text === q.neq) return false;
    else return true;
  }
}
export async function AnnotationTransformation(role, spec, original, specifier, action, option) {
  if (action === "add" && (specifier.index !== undefined || specifier.text !== undefined || specifier.id !== undefined)) {
    spec.annotation?.items?.forEach((annotationItem, ai) => {
      // querying
      let flag = true;
      if (specifier.id !== undefined && specifier.id !== annotationItem.name) flag = false;
      if (specifier.index !== undefined && specifier.index != ai) flag = false;
      if (specifier.text !== undefined && !textmatch(annotationItem, specifier.text)) flag = false;
      if (flag) {
        // normalizing
        if (annotationItem.text === undefined) annotationItem.text = [];
        if (annotationItem.text?.constructor.name === "Object") annotationItem.text = [annotationItem.text];
        // adding
        if (option.text) annotationItem.text.push(option.text)
      }
    })
  } else {
    let toRemove = [];
    let fcnt = 0;
    let aCount = 0;
    spec.annotation?.items.forEach((annoItem, ai) => {
      let flag = (annoItem.type === "text");
      // filtering: index, text...
      if (flag) {
        if (specifier.id !== undefined && annoItem.name !== specifier.id) flag = false;
        if (specifier.index !== undefined && aCount !== specifier.index) flag = false;
        if (specifier.text !== undefined) {
          if (specifier.text.constructor.name !== "Array") {
            specifier.text = [specifier.text]
          }
          specifier.text.forEach(textQuery => {
            if (textQuery.items !== undefined) {
              flag = textQuery.items.map((titem, tii) => {
                return makeFilterFunction(titem, true)(annoItem.text[tii]?.text)
              }).every(d => d);
            } else {
              flag = makeFilterFunction(specifier.text, true)(annoItem?.text?.map(d => d.text).join(" "))
            }
          })
        }
      }
      if (flag) {
        fcnt += 1;
        if (action === "remove") {
          // todo
          toRemove.push(ai);
        } else if (action === "modify" || action === "reposition") {
          // todo
          Object.keys(option || {}).forEach(propertyKey => {
            if (!["role"].includes(propertyKey)) {
              if (propertyKey === "text") {
                if (option[propertyKey].constructor.name === "Array") {
                  option[propertyKey].forEach((newText, nti) => {
                    if (newText.constructor.name === "String") annoItem.text[nti].text = newText;
                    else if (newText.constructor.name === "Object") {
                      if (option.text.index !== undefined && option.text.index != nti) return;
                      Object.keys(newText).forEach(subpropertyKey => {
                        let _subpropertyKey = { "textAlign": "align" }[subpropertyKey] || subpropertyKey;
                        if (newText[propertyKey] !== null) annoItem.text[nti][_subpropertyKey] = newText[propertyKey]
                        else delete annoItem.text[nti][_subpropertyKey];
                      })
                    }
                  });
                } else if (option[propertyKey].constructor.name === "String") {
                  if (annoItem.text.constructor.name === "Array") annoItem.text[0][propertyKey] = option[propertyKey];
                  else if (annoItem.text.constructor.name === "Object") annoItem.text[propertyKey] = option[propertyKey];
                } else if (option[propertyKey].constructor.name === "Object") {
                  // todo
                  annoItem.text?.forEach((textItem, ti) => {
                    if (option.text.index !== undefined && option.text.index != ti) return;
                    Object.keys(option.text).forEach(subProp => {
                      let _subProp = { textAlign: "align", color: "fontColor" }[subProp] || subProp;
                      if (option.text[subProp] !== null) {
                        textItem[_subProp] = option.text[subProp];
                      }
                      else delete textItem[_subProp];
                    })
                  })
                }
              } else if (propertyKey === "external") {
                if (option[propertyKey] === null) delete annoItem.visibility?.externalize;
                else if (option[propertyKey].constructor.name === "Array") {
                  if (annoItem.visibility === undefined) annoItem.visibility = {};
                  if (option[propertyKey][fcnt - 1] !== null) annoItem.visibility.externalize = { "position": "bottom" };
                  else delete annoItem.visibility?.externalize;
                } else {
                  if (annoItem.visibility === undefined) annoItem.visibility = {};
                  if (option[propertyKey]) {
                    annoItem.visibility.externalize = { "position": "bottom" };
                  } else {
                    delete annoItem.visibility.externalize;
                  }
                }
              } else if (propertyKey === "numbering") {
                if (option[propertyKey] === null) delete annoItem.visibility?.externalize?.numbering;
                if (annoItem.visibility.externalize) {
                  annoItem.visibility.externalize.numbering = option[propertyKey];
                }
              } else if (propertyKey === "position") {
                if (option[propertyKey].constructor.name === "Array") {
                  if (option.external || option[fcnt - 1]?.external || annoItem.visibility?.externalize !== undefined) {
                    if (annoItem.visibility === undefined) annoItem.visibility = {};
                    if (annoItem.visibility.externalize == undefined) annoItem.visibility.externalize = {};
                    annoItem.visibility.externalize.position = option[propertyKey][fcnt - 1];
                  }
                  else delete annoItem.visibility?.externalize?.position;
                } else {
                  if (annoItem.visibility === undefined) annoItem.visibility = {};
                  if (annoItem.visibility.externalize == undefined) annoItem.visibility.externalize = {};
                  if (option[propertyKey]) {
                    annoItem.visibility.externalize.position = option[propertyKey];
                  } else {
                    delete annoItem.visibility?.externalize?.position;
                  }
                }
              } else if (option[propertyKey]?.constructor.name === "Array") {
                if (option[propertyKey][fcnt - 1] !== null) annoItem[propertyKey] = option[propertyKey][fcnt - 1]
                else delete annoItem[propertyKey]
              } else if (["align", "fontSize", "textAlign", "fontColor"].includes(propertyKey)) {
                let _propertyKey = { "textAlign": "align" }[propertyKey] || propertyKey;
                if (annoItem.text.constructor.name === "Array") {
                  annoItem.text.forEach(textElem => {
                    if (option[propertyKey] !== null) textElem[_propertyKey] = option[propertyKey]
                    else delete textElem[_propertyKey]
                  })
                } else {
                  if (option[propertyKey] !== null) annoItem.text[_propertyKey] = option[propertyKey]
                  else delete annoItem.text[_propertyKey]
                }
              } else if (propertyKey === "box") {
                if (annoItem.box === undefined) annoItem.box = {};
                Object.keys(option.box).forEach(boxProp => {
                  if (option.box[boxProp] !== null) annoItem.box[boxProp] = option.box[boxProp];
                  else delete annoItem.box[boxProp];
                })
              } else if (["dataAnchor", "orient", "anchor"].includes(propertyKey)) {
                if (annoItem.anchor === undefined) annoItem.anchor = {};
                let _propertyKey = { dataAnchor: "dataItem", orient: "positionOrient", anchor: "anchorAlign" }[propertyKey];
                if (option[propertyKey] === null) {
                  delete annoItem.anchor[_propertyKey];
                } else {
                  annoItem.anchor[_propertyKey] = option[propertyKey];
                }
              } else if (propertyKey === "tick") {
                if (option[propertyKey] === null) {
                  delete annoItem.anchor?.callout;
                } else if (option[propertyKey].constructor.name === "Boolean") {
                  if (annoItem.anchor === undefined) annoItem.anchor = {};
                  annoItem.anchor.callout = option[propertyKey] ? "yes" : "no";
                } else if (option[propertyKey].constructor.name === "Object") {
                  if (annoItem.anchor === undefined) annoItem.anchor = {};
                  let isAutoFlip = false, flipBy = [];
                  Object.keys(option[propertyKey]).forEach((subKey) => {
                    if (subKey === "cornering") {
                      if (option[propertyKey][subKey] === null) delete annoItem.anchor?.[subKey];
                      else if (option[propertyKey][subKey] === "auto-flip") {
                        isAutoFlip = true;
                      }
                      else annoItem.anchor[subKey] = option[propertyKey][subKey];
                    } else if (["from", "to"].includes(subKey)) {
                      Object.keys(option[propertyKey][subKey]).forEach((subSubKey) => {
                        if (option[propertyKey][subKey][subSubKey] === null) delete annoItem.anchor?.[subKey]?.[subSubKey];
                        else {
                          let ref, org, cvt;
                          if (["x", "dx"].includes(subSubKey)) ref = spec.layout.width;
                          if (["y", "dy"].includes(subSubKey)) ref = spec.layout.height;
                          if (annoItem.anchor[subKey] === undefined) annoItem.anchor[subKey] = {};
                          org = annoItem.anchor[subKey][subSubKey];
                          annoItem.anchor[subKey][subSubKey] = optionOperation(annoItem.anchor[subKey][subSubKey], option[propertyKey][subKey][subSubKey], ref);
                          cvt = annoItem.anchor[subKey][subSubKey];
                          if (Math.sign(org) != Math.sign(cvt)) {
                            flipBy.push(subSubKey);
                          }
                        }
                      })
                    }
                  });
                  if (isAutoFlip && flipBy.length > 0 && option.tick.cornering) {
                    if (flipBy.includes("dx") || flipBy.includes("x")) {
                      if (annoItem.anchor.cornering?.includes("left"))
                        annoItem.anchor.cornering = annoItem.anchor.cornering.replace("left", "right");
                      else if (annoItem.anchor.cornering?.includes("right"))
                        annoItem.anchor.cornering = annoItem.anchor.cornering.replace("right", "left");
                    }

                    if (flipBy.includes("dy") || flipBy.includes("y")) {
                      if (annoItem.anchor.cornering?.includes("top"))
                        annoItem.anchor.cornering = annoItem.anchor.cornering.replace("top", "bottom");
                      else if (annoItem.anchor.cornering?.includes("bottom"))
                        annoItem.anchor.cornering = annoItem.anchor.cornering.replace("bottom", "top");
                    }
                  }
                }
              } else {
                let ref;
                if (["x", "dx"].includes(propertyKey)) ref = spec.layout.width;
                if (["y", "dy"].includes(propertyKey)) ref = spec.layout.height;
                if (option[propertyKey] !== null) annoItem[propertyKey] = optionOperation(annoItem[propertyKey], option[propertyKey], ref);
                else delete annoItem[propertyKey]
              }
            }
          })
        } else if (action === "replace") {
          // todo
          if (option?.to) {
            if (option.to.role === "title") {
              if (spec.title === undefined) spec.title = {};
              if (spec.title.items === undefined) spec.title.items = [];
              if (annoItem.width !== undefined && spec.title.width === undefined) {
                spec.title.width = annoItem.width;
              }
              if (annoItem.fill !== undefined && spec.title.fill === undefined) {
                spec.title.fill = annoItem.fill;
              }
              annoItem.text.forEach(annoElem => {
                spec.title.items.push(annoElem);
              })
              toRemove.push(ai);
            }
            Object.keys(option.to).forEach(propertyKey => {
              if (!["role", "items"].includes(propertyKey)) {
                if (option.to[propertyKey] !== null) spec.title[propertyKey] = option.to[propertyKey]
                else delete spec.title[propertyKey]
              } else if (propertyKey === "items") {
                let itemOptions;
                if (option.to.items.constructor.name === "Object") {
                  itemOptions = [option.to.items];
                } else if (option.to[propertyKey].constructor.name === "Array") {
                  itemOptions = option.to.items;
                }
                itemOptions.forEach((oitem) => {
                  spec.title.items.forEach((titleItem, ti) => {
                    if (oitem?.index !== undefined && oitem?.index !== ti) return;
                    Object.keys(oitem || {}).forEach((_prop) => {
                      let _propertyKey = { "textAlign": "align" }[_prop] || _prop;
                      if (oitem[_prop] != null) titleItem[_propertyKey] = oitem[_prop];
                      else delete titleItem[_propertyKey];
                    })
                  })
                })
              }
            })
          }
        }
      }
      aCount += 1;
    });
    if (spec.annotation?.items?.length > 0) {
      spec.annotation.items = spec.annotation.items.filter((aitem, ai) => !toRemove.includes(ai));
    }
  }
  return spec;
}